import React from "react";
import Style from "./Packing.module.scss";
import { SearchFilters } from "@wac-ui-dashboard/wac_component_library";
import GliCardListing from "../../Global/GliCardLIsting";
import usePacking from "./usePacking";
import PackingDetails from "./PackingDetails";

const EmployeePacking = () => {
  const {
    states,
    showDetail,
    isLoading,
    totalLength,
    apiStatus,
    activeCard,
    detailId,
    setIsLoading,
    handleInputSearch,
    handleLoadMore,
    handleChange,
    handleSearch,
  } = usePacking();

  return (
    <>
      <div className="row pro-mb-4">
        <div className="col pro-d-flex gap-2 max-w-max">
          <SearchFilters
            showDateRange={false}
            onSearchInput={handleInputSearch}
            showFilters={true}
            showActions={false}
            SearchIcon={
              <span className="material-symbols-outlined"> search </span>
            }
            searchInputProps={{onKeyDown: (e) => e.key === 'Enter' && handleSearch() }}
          />
          {/* <div className={`col-auto`}> */}
            <button
              className="pro-btn pro-btn-primary pro-ms-2"
              type="button"
              onClick={handleSearch}
            >
              <span className="material-symbols-outlined">search</span>
              Search
            </button>
          {/* </div> */}
        </div>
      </div>
      <div className={Style.varifaication_main_wrap}>
        <div className="row">
          <div className={`col-xxl-3 col-4 ${Style.card_main_wrapper} `}>
            <div className={`pro-d-flex ${Style.card_flow_wrap}`}>
              {states.length === 0 ? null : (
                <GliCardListing
                  data={states}
                  isLoading={isLoading}
                  totalLength={totalLength}
                  activeCard={activeCard}
                  handleChange={handleChange}
                  handleLoadMore={handleLoadMore}
                  setIsLoading={setIsLoading}
                  apiStatus={apiStatus}
                  refBottom
                />
              )}
            </div>
          </div>

          <div
            className={`col-xxl-9 col-8 pro-pe-0 ${Style.table_main_wrapper}`}
          >
            <div className={`${Style.table_flow_wrapper} pro-pe-3`}>
              {showDetail === true ? (
                <>
                  <PackingDetails id={detailId} />
                </>
              ) : (
                <h3>Select One</h3>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeePacking;
